// extracted by mini-css-extract-plugin
module.exports =  {"navBar":"jut__FooterNavBar__navBar","navItem":"jut__FooterNavBar__navItem","navLink":"jut__FooterNavBar__navLink"};